<template>
  <div id="spinner" class="spinner-wrapper hidden">
    <div class="slds-spinner_container slds-is-fixed">
      <div role="status" class="slds-spinner slds-spinner_medium slds-spinner_brand">
        <span class="slds-assistive-text">Loading</span>
        <div class="slds-spinner__dot-a"></div>
        <div class="slds-spinner__dot-b"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Spinner"
}
</script>

<style scoped>

</style>